<template>
  <v-dialog
      :value="value"
      @input="(v) => v || close()"
      hide-overlay
      persistent
      no-click-animation
      fullscreen
  >
    <v-card>
      <v-card-title class="title pa-0 px-2">
        <div style="width: 30%">
          <h5>({{ info.currentIndex + 1 }}/{{ info.list.length }}) {{ info.name }}</h5>
        </div>
        <v-row justify="center" class="show-image" style="position: relative; left: -15%;">
          <v-col cols="auto" align-self="center">
            <v-btn
                fab
                small
                outlined
                @click="previousImage(info.currentIndex)"
            >
              <v-icon small> mdi-less-than </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" align-self="center">
            <v-btn
                fab
                small
                outlined
                @click="nextImage(info.currentIndex)"
            >
              <v-icon small> mdi-greater-than </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-btn fab small class="btn-close" depressed color="grey lighten-1" v-on:click="close()">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <PinchScrollZoom
          :width="screenWidth"
          :height="screenHeight"
      >
        <img :src="info.src" class="image" alt="画像"/>
      </PinchScrollZoom>
    </v-card>
  </v-dialog>
</template>

<script>
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
export default {
  name: "ImageViewDialog",
  props: ['value', 'info'],
  components:{
    PinchScrollZoom
  },
  data(){
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight - 64
    }
  },

  methods: {
    close(){
      this.$emit('input');
    },
    previousImage(index){
      if (index <= 0) {
        const image = this.info.list[0];
        const name_array = image.src.split("/");
        this.info.name = name_array[name_array.length - 1];
        this.info.src = image.src;
        this.info.currentIndex = 0;
        // this.image.rotate = image.rotate;
        // this.image.crop = image.crop;
        this.info.type = image.type;
        // this.image.annotation_mark = image.annotation_mark;
        // this.displayAirprobeAnnotation = !image.filtered;

        // this.reset();
        // this.initCanvas();
      } else {
        const image = this.info.list[index - 1];
        const name_array = image.src.split("/");
        this.info.name = name_array[name_array.length - 1];
        this.info.src = image.src;
        this.info.currentIndex = index - 1;
        // this.image.rotate = image.rotate;
        // this.image.crop = image.crop;
        this.info.type = image.type;
        // this.image.annotation_mark = image.annotation_mark;
        // this.displayAirprobeAnnotation = !image.filtered;

        // this.reset();
        // this.initCanvas();
      }
    },
    nextImage(index){
      if (index >= this.info.list.length - 1) {
        const image = this.info.list[this.info.list.length - 1];
        const name_array = image.src.split("/");
        this.info.name = name_array[name_array.length - 1];
        this.info.src = image.src;
        this.info.currentIndex = this.info.list.length - 1;
        // this.image.rotate = image.rotate;
        // this.image.crop = image.crop;
        this.info.type = image.type;
        // this.image.annotation_mark = image.annotation_mark;
        // this.displayAirprobeAnnotation = !image.filtered;

        // this.reset();
        // this.initCanvas();
      } else {
        const image = this.info.list[index + 1];
        const name_array = image.src.split("/");
        console.log(name_array)
        this.info.name = name_array[name_array.length - 1];
        this.info.src = image.src;
        this.info.currentIndex = index + 1;
        // this.image.rotate = image.rotate;
        // this.image.crop = image.crop;
        this.info.type = image.type;
        // this.image.annotation_mark = image.annotation_mark;
        // this.displayAirprobeAnnotation = !image.filtered;

        // this.reset();
        // this.initCanvas();
      }
    }
  },

  created() {
  }
}
</script>

<style scoped>
.image{
  height: 100%;
  object-fit: contain;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
